export default {
    driverPerformanceFunctionTab_performanceImprovement_performanceImprovement: 'Mejora de Rendimiento',
    driverPerformanceFunctionTab_performanceImprovement_enableDefaultsPI: 'Habilitar Valores por Defecto PI',
    driverPerformanceFunctionTab_performanceImprovement_avgEvents: 'Eventos Promedio',
    driverPerformanceFunctionTab_performanceImprovement_riskScore: 'Puntuación de Riesgo',
    driverPerformanceFunctionTab_performanceImprovement_events: 'Eventos',
    driverPerformanceFunctionTab_performanceImprovement_totalDistance: 'Distancia Total',
    driverPerformanceFunctionTab_performanceImprovement_save: 'Guardar',
    driverPerformanceFunctionTab_performanceImprovement_success: 'Éxito',
    driverPerformanceFunctionTab_performanceImprovement_error: 'Error',
    driverPerformanceFunctionTab_performanceImprovement_updatedConfiguration: 'Configuración actualizada exitosamente',
    driverPerformanceFunctionTab_performanceImprovement_updatedConfigurationError: 'Error al actualizar la configuración',
    driverPerformanceFunctionTab_performanceImprovement_coachingEducationRequired: 'Coaching Education debe estar habilitado antes de activar Mejora de Rendimiento',
    driverPerformanceFunctionTab_performanceImprovement_avgEventsTooltip: 'Rango: 1-10000',
    driverPerformanceFunctionTab_performanceImprovement_riskScoreTooltip: 'Rango: 1-10000',
    driverPerformanceFunctionTab_performanceImprovement_eventsTooltip: 'Rango: 1-10000',
    driverPerformanceFunctionTab_performanceImprovement_totalDistanceTooltip: 'Rango: 1-10000',
    driverPerformanceFunctionTab_performanceImprovement_miles: 'millas',
    driverPerformanceFunctionTab_performanceImprovement_kilometers: 'km'
};
